import { Box } from 'native-base';
import React from 'react';
const SummaryTableWrapper = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    borderColor: "#cccccc",
    borderWidth: 1,
    borderRadius: "md"
  }, children);
};
export default SummaryTableWrapper;
//# sourceMappingURL=index.js.map